import React, { useContext } from "react";
import { Box, Flex, Text, TransparentButton, Divider } from "flicket-ui";
import { Icon } from "~components";
import { BaseContext } from "~context";
import { Layout } from "~components/common/Layout";
import { EventQuery } from "~graphql/sdk";
import { Desktop } from "./detail.Desktop";
import { Mobile } from "./detail.Mobile";
import { useIsMobile } from "~hooks";
import MainCTA from "../events.MainCTA";
import ReleaseCodes from "../events.ReleaseCodes";
import useShowReleaseCodes from "~features/events/hooks/useShowReleaseCodes";

export type DetailsProps = {
  event: EventQuery["event"];
  releaseIsActive?: boolean;
};

export const Detail = ({ event, releaseIsActive }: DetailsProps) => {
  const isMobile = useIsMobile();
  const { isSinglePage } = useContext(BaseContext);
  const showReleaseCodes = useShowReleaseCodes(event.enableReleaseCodes);

  const footerHeight = showReleaseCodes ? "200px" : "70px";

  return (
    <>
      {isMobile && (
        <>
          <Box
            d={{ _: "flex", md: "none" }}
            flexDirection="column"
            flex={1}
            pt={isSinglePage ? 8 : 0}
          >
            {!isSinglePage && (
              <>
                <Flex px={2} py={2} alignItems={"center"}>
                  <TransparentButton href="/events">
                    <Icon icon="chevron-left" fontSize={6} />
                  </TransparentButton>
                  <Text
                    lineHeight="normal"
                    fontSize={3}
                    fontWeight="extraBold"
                    color="N800"
                    ml={2}
                  >
                    {event.title}
                  </Text>
                </Flex>
                <Divider />
              </>
            )}
            <Layout
              pt={{ _: "0 !important" as any, md: 8 }}
              paddingBottom={footerHeight as any}
              layoutType="sub"
            >
              <Mobile event={event} />
            </Layout>
            <Flex
              height={footerHeight}
              flexDirection={"column"}
              justifyContent={"center"}
              position={"fixed"}
              bottom={0}
              left={0}
              right={0}
              px={2}
              py={1}
              background="white"
              borderTop={"1px solid"}
              borderColor={"N200"}
            >
              <MainCTA event={event} releaseIsActive={releaseIsActive} />
              <ReleaseCodes event={event} />
            </Flex>
          </Box>
        </>
      )}
      {!isMobile && (
        <Box d={{ _: "none", md: "flex" }} flexDirection="column" flex={1}>
          <Layout layoutType="main">
            <Desktop
              event={event}
              showSeatsCTA={releaseIsActive ?? event?.hasPublicRelease}
              releaseIsActive={releaseIsActive}
              isSinglePage={isSinglePage}
            />
          </Layout>
        </Box>
      )}
    </>
  );
};
